import { useQuery } from "@tanstack/react-query";
import {
  type ShowErrorToastFn,
  useToast
} from "../../../mantine/notifications/useToast";
import { pollTaskStatus } from "../../../utils/api-utils";
import type { MetersSuggestions } from "../../../utils/backend-types";
import { findMetersSuggestions } from "../utils/findMetersSuggestions";
import { getMetersSuggestions } from "../utils/getMetersSuggestions";

export function useLoadSuggestedMeters(configurationId: number) {
  const { showErrorToast } = useToast();

  return useQuery({
    queryKey: ["load-suggested-meters", configurationId, showErrorToast],
    queryFn: () => getSuggestedMeters(configurationId, showErrorToast),
    enabled: false
  });
}

async function getSuggestedMeters(
  configurationId: number,
  showErrorToast: ShowErrorToastFn
): Promise<MetersSuggestions[]> {
  try {
    const findMetersSuggestionsData =
      await findMetersSuggestions(configurationId);

    return new Promise((resolve) => {
      pollTaskStatus(
        findMetersSuggestionsData.taskStatusUrl,
        () => {
          resolve(getMetersSuggestions(findMetersSuggestionsData.taskIds[0]));
        },
        () => {
          resolve(getMetersSuggestions(findMetersSuggestionsData.taskIds[0]));
        },
        1000
      );
    });
  } catch (error) {
    showErrorToast(error);
    return [];
  }
}
